<template>
  <div class="dropdown" @click="toggleActive" :class="{ active: isActive }">
    <button class="dropbtn text-bold">{{ UserLogged.user_metadata.full_name }}<div class="icon-person"></div></button>
    <div class="dropdown-content">
      <span></span>
      <router-link v-for="(item, index) in items" :key="index" :to="item.to">{{ item.name }}</router-link>
      <a v-if="UserLogged !== null" class="identity__logout" v-on:click="logoutUser" href="#">Logout</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dropdown',
  props: {
    items: Array,
    logoutUser: Function,
    UserLogged: Object,
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    toggleActive() {
      const w = window.innerWidth;
      this.isActive = !this.isActive;

      if (w <= '768') {
        this.isActive = false;
      }
    },
  },
  watch: {
    $route() {
      this.isActive = false;
    },
  },
};
</script>
